import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { createFileRoute, Link } from "@tanstack/react-router";
import { SavedSearchDetail } from "@/features/saved/SavedSearchDetail";

function SavedDetailPage() {
  const { id } = Route.useParams();
  return (
    <Container maxWidth="lg" disableGutters>
      <Button component={Link} to="/saved" startIcon={<ArrowBackIcon />} sx={{ mb: 1 }}>
        Back to saved searches
      </Button>
      <Typography variant="h4" component="h1" gutterBottom>
        Saved Search
      </Typography>
      <SavedSearchDetail id={id} />
    </Container>
  );
}

export const Route = createFileRoute("/_authed/saved/$id")({
  component: SavedDetailPage,
});
